
import { useParams } from 'react-router-dom'
import { ListKeys, menuGroupList, modulesList } from '../../../api/list'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { createMenu, getMenubyId, updateMenu } from './apiCall'
import { MenuKeys } from './entity'

export default function MenuEdit() {
  let { id } = useParams();

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TextInput,
      name: 'Name',
      label: 'Name',
      value: null,
      required: true,
      maxLength: 100,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'ModuleId',
      label: 'Module',
      value: null,
      displayExpr: "DisplayName",
      valueExpr: "id",
      getListData: modulesList,
      apiKey: ListKeys.modules,
      required: true,
      disabled: !!id
    },
    {
      type: FormItemTypes.TextInput,
      name: 'Routes',
      label: 'Routes',
      value: null,
      required: true,
      valueTypes: ValueTypes.urlPath
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'MenuGroupId',
      label: 'Menu Group',
      value: null,
      displayExpr: "Name",
      valueExpr: "id",
      getListData: menuGroupList,
      apiKey: ListKeys.menuGroup,
      disabled: !!id
    },
    {
      type: FormItemTypes.TextInput,
      name: 'LogoPath',
      label: 'Logo Path',
      value: null,
      required: true,
      valueTypes: ValueTypes.urlPath
    },
    {
      type: FormItemTypes.NumberInput,
      name: 'Sequence',
      label: 'Sequence',
      value: null,
      required: true,
      valueTypes: ValueTypes.number,
      inputMode: 'numeric',
      maxLength: 5
    },
  ]

  return (
    <FormBuilderContainer
      formData={formData}

      getFormAPI={getMenubyId}
      getRequest={{ id: id }}
      getKey={MenuKeys.get}

      createFormAPI={createMenu}
      createKey={MenuKeys.create}

      updateFormAPI={updateMenu}
      updateKey={MenuKeys.update}

      headerLabel={!id ? 'Add Menu' : 'Menu'}
      parentPath={'/menu'}
    />
  )
}
